<script setup>
import SubmitButton from '@/Components/SubmitButton.vue';
import LandingLayout from '@/Layouts/Layout.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import FormHeader from '@/Components/FormHeader.vue';

defineProps({
    status: String,
});

const form = useForm({
    email: '',
});

const submit = () => {
    form.post(route('password.email'));
};
</script>

<template>
    <LayoutNew>
        
        
        <div style="max-width: 450px; width: 100%;">
            <FormHeader v-bind:title="__('Zapomniałeś hasła?')"/>
            <p class="mb-4 alert alert-secondary" v-text="__('Zapomniałeś hasła? Nie ma problemu. Podaj nam swój adres e-mail, a my wyślemy Ci link do resetowania hasła, który pozwoli Ci wybrać nowe.')"/>

            <BreezeValidationErrors class="mb-2 alert alert-danger" />
            <div v-if="status" class="mb-2 alert alert-info">
                {{ status }}
            </div>
            <form @submit.prevent="submit">
                <div class="mb-2">
                    <label for="email" class="form-label" v-text="__( 'Adres Email' )"/>
                    <BreezeInput v-bind:placeholder="__('Wprowadź swój adres e-mail')" id="email" type="email" class="form-control" v-model="form.email" required autofocus autocomplete="username" />
                    <div class="error" id="emailError"></div>
                </div>
                <SubmitButton v-bind:text="__( 'Wyślij link resetujący pocztą')" />
            </form>
        </div>
        
    </LayoutNew>
</template>